import { setupAuthClient } from '@jq4race/api-client';

import { env } from './env';

export function initAuthClient(): void {
  setupAuthClient({ baseUrl: env.apiBaseUrl, authBaseUrl: env.authBaseUrl });
}
